export enum PosStatusType {
  POS_UNSET = 'POS_UNSET', // Do not use, needed because of proto3 limitations
  POS_PENDING = 'POS_PENDING',
  POS_ACTIVATED = 'POS_ACTIVATED',
  POS_DEACTIVATED = 'POS_DEACTIVATED',
}
